import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { CoursesService } from 'src/app/services/courses.service';
import { QuizService } from 'src/app/services/quiz.service';
import { PDFDocument } from 'pdf-lib'
import { FileHelper } from 'src/app/helpers';
import { QuizQuestion } from 'src/app/models';

@Component({
  selector: 'app-module3-rw',
  templateUrl: './module3-rw.component.html',
  styleUrls: ['./module3-rw.component.css', '../rentwise.component.css']
})
export class Module3RwComponent implements OnInit {

  module = 3;
  page = 1;

  flag = false;

  balance = 28;

  model = {
    priority1: 0,
    priority2: 0,
    priority3: 0,
    priority4: 0,
    priority5: 0,
    priority6: 0,
    priority7: 0,
    priority8: 0,
    priority9: 0,
    priority10: 0,
    priority11: 0,
    priority12: 0,
    priority13: 0,
    priority14: 0,
    priority15: 0,


  };

  lastChoice = {
    lastChoice1: 0,
    lastChoice2: 0,
    lastChoice3: 0,
    lastChoice4: 0,
    lastChoice5: 0,
    lastChoice6: 0,
    lastChoice7: 0,
    lastChoice8: 0,
    lastChoice9: 0,
    lastChoice10: 0,
    lastChoice11: 0,
    lastChoice12: 0,
    lastChoice13: 0,
    lastChoice14: 0,
    lastChoice15: 0,
  }

  srcHandout: string = "../../../../../assets/RWM3A3Handout.pdf";
  pdfHandoutFillable!: PDFDocument;



  // Contains all questions for the module
  questions: QuizQuestion[] = [];

  constructor(private courseService: CoursesService, private router: Router, private quizService: QuizService) { }

  async ngOnInit(): Promise<void> {
    this.courseService.setCurrentCourseBy('RentWise');

    // Open the furthest page
    if (this.courseService.currentCourse.furthestModuleID === this.module - 1) {
      this.page = this.courseService.currentCourse.furthestPageID + 1;
    }

    // Get the questions for this module and assign them to this.questions
    this.quizService.getModuleQuizzes("61f3434ffadf713839b08cdb").toPromise().then((res: any) => {
      this.quizService.moduleQuizQuestions = res.docs;
      this.questions = this.quizService.moduleQuizQuestions;
    });
    const handoutFillablePdfBytes = await fetch("../../../../../assets/RWM3A3Handout.pdf").then(res => res.arrayBuffer());
    this.pdfHandoutFillable = await PDFDocument.load(handoutFillablePdfBytes);

  }

  // Update furthestModuleID
  updateProgress() {
    if (this.courseService.currentCourse.furthestModuleID < this.module) {
      this.courseService.updateFurthestModule().toPromise().then((res: any) => {
        console.log(res);
      });
    }
  }

  // Update furthestPageID
  updatePageProgress() {
    if (this.courseService.currentCourse.furthestModuleID === this.module - 1) {
      if (this.courseService.currentCourse.furthestPageID < this.page) {
        this.courseService.updateFurthestPage(this.page).toPromise();
      }
    }
  }

  // Handle the quiz results, allow them to pass or not
  handleQuiz(valueEmitted: boolean){

    // Quiz passed
    if (valueEmitted) {
      this.updateProgress();
      this.router.navigate(['/module4-rw']);
    }

    // Review
    else {
      this.page = 1
    }
  }

  next(event?: Event) {
    if (event?.defaultPrevented) return false;
    this.page += 1;
    window.scrollTo(0,0);
    this.updatePageProgress();
    return true;
  }

  back(){
    this.page -= 1;
    window.scrollTo(0,0);
    return true;
  }

  async downloadHandoutPdf () {
    // Serialize the PDFDocument to bytes (a Uint8Array) for download
    const pdfBytes = await this.pdfHandoutFillable.save();
    FileHelper.saveByteArray('RWM3A3Handout.pdf', pdfBytes, 'application/pdf');
  }

  activityOneModel = {
    q1 : false,
    q2 : false,
    q3 : false,
    q4 : false,
    q5 : false,
    q6 : false,
    q7 : false,
    q8 : false,
    q9 : false,
    q10 : false,
    q11 : false,
    q12 : false,
    q13 : false,
    q14 : false,
    q15 : false,
  }

  selectQ1()
  {
    this.activityOneModel.q1 = true;
  }
  selectQ2()
  {
    this.activityOneModel.q2 = true;
  }
  selectQ3()
  {
    this.activityOneModel.q3 = true;
  }
  selectQ4()
  {
    this.activityOneModel.q4 = true;
  }
  selectQ5()
  {
    this.activityOneModel.q5 = true;
  }
  selectQ6()
  {
    this.activityOneModel.q6 = true;
  }
  selectQ7()
  {
    this.activityOneModel.q7 = true;
  }
  selectQ8()
  {
    this.activityOneModel.q8 = true;
  }
  selectQ9()
  {
    this.activityOneModel.q9 = true;
  }
  selectQ10()
  {
    this.activityOneModel.q10 = true;
  }
  selectQ11()
  {
    this.activityOneModel.q11 = true;
  }
  selectQ12()
  {
    this.activityOneModel.q12 = true;
  }
  selectQ13()
  {
    this.activityOneModel.q13 = true;
  }
  selectQ14()
  {
    this.activityOneModel.q14 = true;
  }
  selectQ15()
  {
    this.activityOneModel.q15 = true;
  }



  setFlag()
  {
    this.flag = true;
  }
  resetFlag()
  {
    this.flag = false;
  }
  activityOneChecked()
  {
    if (this.activityOneModel.q1 == false || this.activityOneModel.q2 == false || this.activityOneModel.q3 == false || this.activityOneModel.q4 == false || this.activityOneModel.q5 == false || this.activityOneModel.q6 == false || this.activityOneModel.q7 == false || this.activityOneModel.q8 == false || this.activityOneModel.q9 == false || this.activityOneModel.q10 == false || this.activityOneModel.q11 == false || this.activityOneModel.q12 == false || this.activityOneModel.q13 == false || this.activityOneModel.q14 == false || this.activityOneModel.q15 == false)
    {
      return false;
    }
    return true;
  }

  updateOne(){
    if (this.lastChoice.lastChoice1 != this.model.priority1) {
      this.balance = this.balance + this.lastChoice.lastChoice1;
    }
    this.balance = this.balance - this.model.priority1;
    this.lastChoice.lastChoice1 = this.model.priority1;
  }

  updateTwo(){
    if (this.lastChoice.lastChoice2 != this.model.priority2) {
      this.balance = this.balance + this.lastChoice.lastChoice2;
    }
    this.balance = this.balance - this.model.priority2;
    this.lastChoice.lastChoice2 = this.model.priority2;
  }

  updateThree(){
    if (this.lastChoice.lastChoice3 != this.model.priority3) {
      this.balance = this.balance + this.lastChoice.lastChoice3;
    }
    this.balance = this.balance - this.model.priority3;
    this.lastChoice.lastChoice3 = this.model.priority3;
  }

  updateFour(){
    if (this.lastChoice.lastChoice4 != this.model.priority4) {
      this.balance = this.balance + this.lastChoice.lastChoice4;
    }
    this.balance = this.balance - this.model.priority4;
    this.lastChoice.lastChoice4 = this.model.priority4;
  }

  updateFive(){
    if (this.lastChoice.lastChoice5 != this.model.priority5) {
      this.balance = this.balance + this.lastChoice.lastChoice5;
    }
    this.balance = this.balance - this.model.priority5;
    this.lastChoice.lastChoice5 = this.model.priority5;
  }

  updateSix(){
    if (this.lastChoice.lastChoice6 != this.model.priority6) {
      this.balance = this.balance + this.lastChoice.lastChoice6;
    }
    this.balance = this.balance - this.model.priority6;
    this.lastChoice.lastChoice6 = this.model.priority6;
  }

  updateSeven(){
    if (this.lastChoice.lastChoice7 != this.model.priority7) {
      this.balance = this.balance + this.lastChoice.lastChoice7;
    }
    this.balance = this.balance - this.model.priority7;
    this.lastChoice.lastChoice7 = this.model.priority7;
  }

  updateEight(){
    if (this.lastChoice.lastChoice8 != this.model.priority8) {
      this.balance = this.balance + this.lastChoice.lastChoice8;
    }
    this.balance = this.balance - this.model.priority8;
    this.lastChoice.lastChoice8 = this.model.priority8;
  }

  updateNine(){
    if (this.lastChoice.lastChoice9 != this.model.priority9) {
      this.balance = this.balance + this.lastChoice.lastChoice9;
    }
    this.balance = this.balance - this.model.priority9;
    this.lastChoice.lastChoice9 = this.model.priority9;
  }

  updateTen(){
    if (this.lastChoice.lastChoice10 != this.model.priority10) {
      this.balance = this.balance + this.lastChoice.lastChoice10;
    }
    this.balance = this.balance - this.model.priority10;
    this.lastChoice.lastChoice10 = this.model.priority10;
  }

  updateEleven(){
    if (this.lastChoice.lastChoice11 != this.model.priority11) {
      this.balance = this.balance + this.lastChoice.lastChoice11;
    }
    this.balance = this.balance - this.model.priority11;
    this.lastChoice.lastChoice11 = this.model.priority11;
  }

  updateTwelve(){
    if (this.lastChoice.lastChoice12 != this.model.priority12) {
      this.balance = this.balance + this.lastChoice.lastChoice12;
    }
    this.balance = this.balance - this.model.priority12;
    this.lastChoice.lastChoice12 = this.model.priority12;
  }

  updateThirteen(){
    if (this.lastChoice.lastChoice13 != this.model.priority13) {
      this.balance = this.balance + this.lastChoice.lastChoice13;
    }
    this.balance = this.balance - this.model.priority13;
    this.lastChoice.lastChoice13 = this.model.priority13;
  }

  updateFourteen(){
    if (this.lastChoice.lastChoice14 != this.model.priority14) {
      this.balance = this.balance + this.lastChoice.lastChoice14;
    }
    this.balance = this.balance - this.model.priority14;
    this.lastChoice.lastChoice14 = this.model.priority14;
  }

  updateFifteen(){
    if (this.lastChoice.lastChoice15 != this.model.priority15) {
      this.balance = this.balance + this.lastChoice.lastChoice15;
    }
    this.balance = this.balance - this.model.priority15;
    this.lastChoice.lastChoice15 = this.model.priority15;

  }

  @ViewChild('stickyMenu') menuElement!: ElementRef;
  sticky: boolean = false;
  elementPosition!: any;

  ngAfterViewInit(){
    this.elementPosition = 1100;
  }


  @HostListener('window:scroll', ['$event'])
  handleScroll(){
    console.log(this.elementPosition)
    const windowScroll = window.pageYOffset;
    if(windowScroll >= this.elementPosition){
      this.sticky = true;

    } else {
      this.sticky = false;
    }
  }
}
